import { render, staticRenderFns } from "./PreviewImage.pug?vue&type=template&id=480a93c3&lang=pug&"
import script from "./PreviewImage.vue?vue&type=script&lang=js&"
export * from "./PreviewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports